<app-modal [modalConfig]="modalConfig">
    <div class="change-password">
        <div class="input-container">
            <label>
                Contraseña Actual
                <span class="mandatory">*</span>
            </label>
            <input class="form-input" [formControl]="oldPassword" type="password" [ngClass]="{'error':hasErrors()}">
        </div>
        <app-password [isLoading]="isLoading" (passwordEvent)="onSubmit($event)"></app-password>
    </div>
    <ngx-loading [show]="isLoading">
    </ngx-loading>
</app-modal>